import _ from 'lodash'

const state = {
  // 员工校验规则
  rules: (form) => {
    function isValidText (str) {
      const reg = /^([^\s])*$/g
      let result = reg.test(str)
      return result
    }

    function isValidPhone (str) {
      // const reg = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/
      const reg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/
      return reg.test(str)
    }

    function validPhone (rule, value, callback) {
      if (value) {
        value = _.trim(value)
        if (!isValidPhone(value)) {
          callback(new Error('请输入正确的11位手机号码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    function validEmail (rule, value, callback) {
      if (value) {
        value = _.trim(value)
        if (!/^[\S]*$/.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    function validEmployeeNumber (rule, value, callback) {
      if (!/^[a-zA-Z0-9]*$/g.test(value)) {
        callback(new Error('只支持英文，数字'))
      } else if (!isValidText(value)) {
        callback(new Error('不可包含空格'))
      } else {
        callback()
      }
    }

    function validEntranceCardID (rule, value, callback) {
      if (!/^[a-zA-Z0-9]*$/g.test(value)) {
        callback(new Error('只支持英文，数字'))
      } else if (!isValidText(value)) {
        callback(new Error('不可包含空格'))
      } else {
        callback()
      }
    }
    /* function validText (rule, value, callback) {
      if (!value) {
        if (/^[a-zA-Z\u4e00-\u9fa5 ]{1,20}$/.test(value)) {
          callback()
        } else {
          callback('请输入正确的名字')
        }
      } else {
        callback()
      }
    } */

    function validText (rule, value, callback) {
      if (value) {
        value = _.trim(value)
        if (/^\s.*$/.test(value)) { // 开头为空格
          callback(new Error('不支持空格开头'))
        // } else if (/[0-9]+/.test(value) && /[^0-9a-zA-Z\u4e00-\u9fa5]+/.test(value)) { // 数字和特殊字符同时存在
        //   callback(new Error('不支持数字和特殊字符'))
        // } else if (/[0-9]+/.test(value)) { // 只存在数字
        //   callback(new Error('不支持数字'))
        // } else if (!/^[a-zA-Z\u4e00-\u9fa5]{1}[a-zA-Z\u4e00-\u9fa5 ]{0,29}$/.test(value)) { // 只存在特殊字符
        //   // callback('请输入正确的名字')
        //   callback(new Error('不支持特殊字符'))
        } else if (!/^[\S]*$/.test(value)) {
          let tempValue = value.replace(/ +/g, '')
          if (!/^[\S]*$/.test(tempValue)) {
            callback(new Error('请输入正确的名字'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    // function validRolesSelect (rule, value, callback) {
    //   if (form.status) {
    //     if (!value || value.length === 0) {
    //       callback(new Error('请选择角色'))
    //     } else {
    //       callback()
    //     }
    //   } else {
    //     callback()
    //   }
    // }

    // function validCertificateNumberWrited (rule, value, callback) {
    //   console.log(value, form.identity.ID.IDType, 'certificateNumber')
    //   if (value === '' || value === undefined) {
    //     callback(new Error('请输入证件号码'))
    //   } else if (value && value.length > 0) {
    //     validCertificateNumber(rule, value, callback)
    //   } else {
    //     callback()
    //   }
    // }

    function validCertificateNumber (rule, value, callback) {
      /* if (form.certificateType === 0 && !(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(certificateNumber))) {
        callback(new Error('身份证格式不正确'))
      } else if (form.certificateType === 1 && !(/[a-zA-Z\d]{5,}/.test(certificateNumber))) {
        callback(new Error('护照格式不正确'))
      } else {
        callback()
      } */
      console.log('really start validate ' + value + ' ' + form.IDType);
      if (form.IDType === 0 && !(/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value))) {
        callback(new Error('请输入正确的身份证号'))
      } else if (form.IDType === 1 && !(/^[a-zA-Z0-9]*$/.test(value))) {
        callback(new Error('只支持英文，数字'))
      } else {
        callback()
      }
    }

    function validDepartmentID (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入部门'))
      } else {
        callback()
      }
    }

    function valideExtensionNumber (rule, value, callback) {
      if (value) {
        value = _.trim(value)
        if (!(/^[\S]*$/).test(value)) {
          // callback(new Error('请输入正确的分机号'))
          callback(new Error('不支持空格'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    function validUsername (rule, value, callback) {
      if (value) {
        value = _.trim(value)
        if (!(/^[\S]*$/).test(value)) {
          callback(new Error('不支持空格'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    return {
      "employeeNumber": [
        {max: 20, message: '最长20个字符', trigger: 'blur'},
        {trigger: 'blur', validator: validEmployeeNumber}
      ],
      "name": [
        {required: true, message: '请输入姓名', trigger: 'blur'},
        // {max: 30, message: '最长30个字符', trigger: 'blur'},
        {trigger: 'blur', validator: validText, required: true}
      ],
      "tel": [
        {required: true, message: '请输入电话号码', trigger: 'blur'},
        {required: true, validator: validPhone, trigger: 'blur'}
      ],
      "email": [
        {validator: validEmail, trigger: 'blur'}
      ],
      // "role": [
      //   {required: true, message: '请选择角色', trigger: ['blur', 'change']}
      //   // 离职时角色可以为空
      //   // {validator: validRolesSelect, trigger: 'blur, change'}
      // ],
      "IDNumber": [
        {required: true, message: '请输入证件号码', trigger: 'blur'},
        {trigger: 'blur', validator: validCertificateNumber}
      ],
      "orgObjectId": [
        {required: true, validator: validDepartmentID, trigger: ['blur', 'change']}
      ],
      "egCardNumber": [
        {trigger: 'blur', validator: validEntranceCardID}
      ],
      "extensionNumber": [
        {trigger: 'blur', validator: valideExtensionNumber}
      ],
      "userName": [
        {required: true, message: '请输入账号', trigger: 'blur'},
        // {max: 15, message: '最长15个字符', trigger: 'blur'},
        {trigger: 'blur', validator: validUsername}
      ],
      "role": [
        {required: true, message: '请选择角色', trigger: ['blur', 'change']}
      ]
      // remark: [
      //   {max: 500, message: '最长500个字符', trigger: 'blur'}
      // ]
    }
  }
}

const actions = {
  checkPhone ({commit}, object) {
    if (object.value === '' || object.value === null) {
      object.callback()
    }
    let reg = /^1[0-9]{10}$/
    if (reg.test(object.value)) {
      object.callback()
    } else {
      object.callback(new Error('手机格式不正确'))
    }
  },
  // 校验必填项与空格
  checkRequiredAndSpace ({commit}, object) {
    let temp = object.value.toString()
    if (object.value === '' || object.value === null) {
      object.callback('不能为空')
    } else if (object.value.indexOf(' ') >= 0) {
      object.callback('输入字符中不能有空格')
    } else if (temp.length > 25) {
      object.callback('输入过长')
    } else {
      object.callback()
    }
  },
  // 校验正整数 非必填项
  checkPositiveInteger ({commit}, object) {
    let regu = /^[1-9]\d*$/
    if (object.value !== '') {
      if (!regu.test(object.value)) {
        object.callback('必须为正整数')
      } else {
        object.callback()
      }
    } else {
      object.callback()
    }
  },
  // 校验非负整数 非必填项
  checkNonnegativeInteger ({commit}, object) {
    let regu = /^(0|[1-9]\d*)$/
    if (object.value !== '') {
      if (!regu.test(object.value)) {
        object.callback('必须为非负整数')
      } else {
        object.callback()
      }
    } else {
      object.callback()
    }
  },

  // 校验正整数与空格 必填项
  checkPositiveIntegerAndSpace ({commit}, object) {
    if (object.value === '' || object.value === null) {
      object.callback('不能为空')
    } else if (isNaN(object.value) || !/^[0-9]*[1-9][0-9]*$/.test(object.value)) {
      object.callback('请输入正整数')
    } else if (object.value.toString().indexOf(' ') >= 0) {
      object.callback('输入字符中不能有空格')
    } else {
      object.callback()
    }
  },

  // 校验只能是数字、汉字和字母与空格与输入过长
  checkNumberOrSinogramOrLetterAndSpace ({commit}, object) {
    let temp = object.value.toString()
    let regu = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
    if (object.value === '' || object.value === null) {
      object.callback('不能为空')
    } else if (object.value.indexOf(' ') >= 0) {
      object.callback('输入字符中不能有空格')
    } else if (temp.length > 25) {
      object.callback('输入过长')
    } else if (!regu.test(object.value)) {
      object.callback('只能是数字、汉字和字母')
    } else {
      object.callback()
    }
  }
}

export default {
  namespaced: true,
  state,
  actions
}



// WEBPACK FOOTER //
// ./src/store/validate.js